<template>
    <div v-if="data[0]!='clear'" class="box" :style="`background-color:rgb(${data[0]},${data[1]},${data[2]})`"></div>
    <div v-else class="box" style="display:flex;align-items: center;justify-content: center;"> Pulisci</div>
</template>
<script>
export default {
    name: 'BaseCentroid',
    props: {
        data: Array
    }
}
</script>
<style scoped>
.box {
  float: left;
  height: 30px;
  width: 50px;
  margin-bottom: 15px;
  clear: both;
  margin: 2px;
  border-radius:8px
}
</style>